<template>
  <div>

    <b-modal
      ref="modalManual2307"
      size="xl"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      hide-header-close
      modal-class="fullscreen"
      title="Manual BIR Form 2307"
    >
      <b-container
        class="h-100 py-1"
        style="overflow-y: scroll"
        fluid
      >
        <ValidationObserver
          ref="formBusinessPartner"
        >
          <form
            role="form"
            novalidate
            @submit.prevent
          >
            <b-row>
              <b-col
                cols="12"
                md="6"
              >
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="partner name"
                      vid="partner_name"
                      rules="required|max:255"
                    >
                      <b-form-group
                        label="Partner Name"
                        label-for="partner_name"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <b-textarea
                          id="partner_name"
                          v-model="incomePayment.partner_name"
                          rows="3"
                          max-rows="6"
                          maxlength="255"
                          autocomplete="off"
                          :state="errors.length > 0 ? false : null"
                          disabled
                        />
                        <div
                          v-if="errors.length > 0"
                          class="invalid-feedback"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <b-col
                    cols="12"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="tin"
                      vid="tin"
                      rules="required|min:18|max:18"
                    >
                      <b-form-group
                        label="TIN"
                        label-for="partner_tin"
                        label-cols-md="4"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <b-input
                          id="partner_tin"
                          v-model="incomePayment.tin"
                          v-mask="'###-###-###-###NNN'"
                          type="text"
                          maxlength="18"
                          autocomplete="off"
                          :state="errors.length > 0 ? false : null"
                          disabled
                        />
                        <div
                          v-if="errors.length > 0"
                          class="invalid-feedback"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </b-col>

              <b-col
                cols="12"
                md="6"
              >
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="address"
                      vid="address"
                      rules="max:255"
                    >
                      <b-form-group
                        label="Address"
                        label-for="address"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <b-textarea
                          id="address"
                          v-model="incomePayment.address"
                          rows="3"
                          max-rows="6"
                          maxlength="255"
                          autocomplete="off"
                          disabled
                        />
                        <div
                          v-if="errors.length > 0"
                          class="invalid-feedback"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <b-col
                    cols="12"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="zip code"
                      vid="zip_code"
                      rules="max:4"
                    >
                      <b-form-group
                        label="Zip Code"
                        label-for="zip_code"
                        label-cols-md="4"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <b-input
                          id="zip_code"
                          v-model="incomePayment.zip_code"
                          type="text"
                          maxlength="4"
                          autocomplete="off"
                          disabled
                        />
                        <div
                          v-if="errors.length > 0"
                          class="invalid-feedback"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </form>
        </ValidationObserver>
        <ValidationObserver
          ref="formIncomePayments"
        >
          <form
            role="form"
            novalidate
            @submit.prevent
          >
            <b-row>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="year"
                  vid="year"
                  rules="required|max:40"
                >
                  <b-form-group
                    label="Year"
                    label-for="year"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-form-select
                      id="year"
                      v-model="incomePayment.year"
                      :options="options.years"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy || tableIncomePayments.rows.length > 0"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- select year here --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="quarter"
                  vid="quarter"
                  rules="required"
                >
                  <b-form-group
                    label="Quarter"
                    label-for="quarter"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-form-select
                      id="quarter"
                      v-model="incomePayment.main_quarter"
                      :options="options.quarters"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy || fetching.options || tableIncomePayments.rows.length > 0"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- select quarter here --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="tax"
                  name="tax"
                >
                  <b-form-group
                    label="Tax"
                    label-for="fTaxCode"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <v-select
                      v-model="selected.taxCode"
                      input-id="fTaxCode"
                      label="description"
                      clearable
                      taggable
                      append-to-body
                      placeholder="select tax here"
                      :options="options.taxCodes"
                      :disabled="[
                        state.busy,
                        fetching.taxCodes
                      ].some(isTrue => isTrue)"
                      :loading="fetching.taxCodes"
                      :calculate-position="calculateDropPosition"
                      :class="{ 'is-invalid': errors.length > 0 }"
                      @search="searchTaxCodes"
                    >
                      <template #option="{ code, description }">
                        <div class="text-break text-wrap">
                          {{ code }} - {{ description }}
                        </div>
                      </template>
                      <template #selected-option="{ code, description }">
                        <div>
                          {{ code }} - {{ description }}
                        </div>
                      </template>
                      <template #no-options="">
                        no available tax code
                      </template>
                    </v-select>
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="tax description"
                  vid="tax_description"
                  rules="required|max:40"
                >
                  <b-form-group
                    label="Tax Description"
                    label-for="tax_description"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="tax_description"
                      v-model="incomePayment.tax_description"
                      type="text"
                      maxlength="40"
                      autocomplete="off"
                      placeholder="enter tax description here"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="tax code"
                  vid="tax_code"
                  rules="required|max:9"
                >
                  <b-form-group
                    label="Tax Code"
                    label-for="tax_code"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="tax_code"
                      v-model="incomePayment.tax_code"
                      type="text"
                      maxlength="9"
                      autocomplete="off"
                      placeholder="enter tax code here"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="tax percentage"
                  vid="tax_percentage"
                  rules="required|min_value:0"
                >
                  <b-form-group
                    label="Tax Percentage"
                    label-for="tax_percentage"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="tax_percentage"
                      v-model="incomePayment.tax_percentage"
                      type="number"
                      autocomplete="off"
                      min="0"
                      step="0.01"
                      placeholder="enter tax percentage here"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy"
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="tax status"
                  vid="tax_status"
                  rules="required"
                >
                  <b-form-group
                    label="Tax Status"
                    label-for="tax_status"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-form-select
                      id="tax_status"
                      v-model="incomePayment.tax_status"
                      :options="options.taxStatuses"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy || fetching.options"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- select tax status here --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="business tax"
                  vid="business_tax"
                  rules="required"
                >
                  <b-form-group
                    label="Business Tax"
                    label-for="business_tax"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-form-select
                      id="business_tax"
                      v-model="incomePayment.business_tax"
                      :options="options.businessTaxes"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy || fetching.options"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- select business tax here --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="transaction type"
                  vid="transaction_type"
                  rules="required"
                >
                  <b-form-group
                    label="Transaction Type"
                    label-for="transaction_type"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-form-select
                      id="transaction_type"
                      v-model="incomePayment.transaction_type"
                      :options="options.transactionTypes"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy || fetching.options"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- select transaction type here --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="month of quarter"
                  vid="month_of_quarter"
                  rules="required"
                >
                  <b-form-group
                    label="Month of Quarter"
                    label-for="month_of_quarter"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-form-select
                      id="month_of_quarter"
                      v-model="incomePayment.quarter"
                      :options="options.monthQuarters"
                      :state="errors.length > 0 ? false : null"
                      :disabled="state.busy || fetching.options"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- select month of quarter here --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  vid="amount"
                  name="amount"
                  rules="required|currency:1"
                >
                  <b-form-group
                    label="Amount"
                    label-for="pr_amount"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="pr_amount"
                      v-model="maskedFormManual2307.amount"
                      v-mask="currencyMask"
                      type="text"
                      placeholder="enter amount here"
                      class="text-right"
                      autocomplete="off"
                      :state="(errors.length > 0 ? false : null)"
                      :disabled="fetching.businessPartners"
                      @blur="$event => calculateVAT($event.target.value)"
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  vid="taxable_amount"
                  name="taxable amount"
                  rules="required|currency:0"
                >
                  <b-form-group
                    label="Taxable Amount"
                    label-for="pr_taxable_amount"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="pr_taxable_amount"
                      v-model="maskedFormManual2307.taxable_amount"
                      v-mask="currencyMask"
                      type="text"
                      placeholder="0.00"
                      class="text-right"
                      :state="(errors.length > 0 ? false : null)"
                      readonly
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  vid="vat_amount"
                  name="vat amount"
                  rules="required|currency:0"
                >
                  <b-form-group
                    label="Vat Amount"
                    label-for="pr_vat_amount"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="pr_vat_amount"
                      v-model="maskedFormManual2307.vat_amount"
                      v-mask="currencyMask"
                      type="text"
                      placeholder="0.00"
                      class="text-right"
                      :state="(errors.length > 0 ? false : null)"
                      readonly
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  vid="amount_due"
                  name="amount due"
                  rules="required|currency:0"
                >
                  <b-form-group
                    label="Amount Due"
                    label-for="pr_amount_due"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="pr_amount_due"
                      v-model="maskedFormManual2307.amount_due"
                      v-mask="currencyMask"
                      type="text"
                      placeholder="0.00"
                      class="text-right"
                      :state="(errors.length > 0 ? false : null)"
                      readonly
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <ValidationProvider
                  #default="{ errors }"
                  vid="tax_withheld"
                  name="with holding tax"
                  rules="required|currency:0"
                >
                  <b-form-group
                    label="Withholding Tax"
                    label-for="pr_with_holding_tax"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <b-input
                      id="pr_with_holding_tax"
                      v-model="maskedFormManual2307.tax_withheld"
                      v-mask="currencyMask"
                      type="text"
                      placeholder="0.00"
                      class="text-right"
                      :state="(errors.length > 0 ? false : null)"
                      readonly
                    />
                    <div
                      v-if="errors.length > 0"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col
                cols="2"
              >
                <b-form-group
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <template #label>
                    <div style="padding: 2.2px;">
                      &nbsp;
                    </div>
                  </template>
                  <b-button
                    variant="primary"
                    @click.prevent="validateIncomePayment"
                  >
                    {{ state.editing ? 'Update' : 'Add' }} Income Payment
                  </b-button>
                </b-form-group>
              </b-col>

            </b-row>
          </form>
        </ValidationObserver>
        <div class="mt-3">
          <b-table
            ref="tableIncomePayments"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :items="tableIncomePayments.rows"
            :fields="tableIncomePayments.fields"
            :sort-by.sync="tableIncomePayments.sortBy"
            :sort-desc.sync="tableIncomePayments.sortDesc"
            :sort-direction="tableIncomePayments.sortDirection"
            :busy="tableIncomePayments.busy"
          >
            <template #cell(index)="{ index }">
              {{ tableIncomePayments.currentPage * tableIncomePayments.perPage - tableIncomePayments.perPage + (index + 1) }}
            </template>

            <template #cell(action)="{ item, index }">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center gap-2">
                <b-button
                  size="sm"
                  variant="success"
                  :disabled="state.editing"
                  @click="editIncomePayment(item, index)"
                >
                  Edit
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-danger"
                  :disabled="state.editing"
                  @click="deleteIncomePayment(item, index)"
                >
                  Delete
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </b-container>
      <template #modal-footer="{ cancel }">
        <div class="col-12 d-flex justify-content-end px-0 pb-0 mb-0 gap-2">
          <b-button
            size="sm"
            variant="info"
            :disabled="state.busy"
            @click.prevent="onPrint()"
          >
            Print 2307
          </b-button>
          <b-button
            variant="outline-dark"
            :disabled="state.busy"
            @click="cancel()"
          >
            Close <span class="d-none d-md-inline-block">Window</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      ref="modalManual2307Print"
      size="xl"
      scrollable
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      title="Payment Request"
      modal-class="fullscreen"
    >
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-success"
        content-class="scrollable"
      >
        <b-tab
          title="BIR Form No. 2307"
          style="min-height: calc(100vh - 150px);"
        >
          <b-overlay
            rounded
            opacity="1"
            :show="pdfBIR === null"
            spinner-variant="success"
            style="min-height: calc(100vh - 150px);"
          >
            <iframe
              :src="pdfBIR"
              style="width: 100%; min-height: calc(100vh - 150px);"
            />
          </b-overlay>
        </b-tab>
      </b-tabs>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import QUERY from 'lodash'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import BIR2307 from '@/mixins/printing/manual-bir-2307'
import FORMULAS from '@/mixins/formulas'
import MTaxCodes from '@/mixins/maintenances/tax-codes'

import { SSharedList } from '@/services'

export default {
  name: 'Manual2307',

  mixins: [
    MISC,
    FORMATTER,
    BIR2307,
    FORMULAS,
    MTaxCodes
  ],

  data () {
    return {
      currencyMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: false,
        decimalLimit: 2
      }),
      pdfBIR: null,
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        options: false
      },
      options: {
        years: [],
        businessTaxes: [],
        taxCodes: [],
        transactionTypes: [],
        taxStatuses: [],
        quarters: [
          { value: '1st-Q', text: '1st Quarter' },
          { value: '2nd-Q', text: '2nd Quarter' },
          { value: '3rd-Q', text: '3rd Quarter' },
          { value: '4th-Q', text: '4th Quarter' }
        ],
        monthQuarters: [
          { value: '1st-Q', text: '1st Month' },
          { value: '2nd-Q', text: '2nd Month' },
          { value: '3rd-Q', text: '3rd Month' }
        ]
      },
      selected: {
        businessTaxes: null,
        taxCode: null,
        transactionType: null,
        taxStatus: null
      },
      maskedFormManual2307: {
        amount: null,
        taxable_amount: 0.00,
        tax_withheld: 0.00,
        vat_amount: 0.00,
        amount_due: 0.00
      },
      businessPartner: {
        partner_name: null,
        tax_description: null,
        tax_code: null,
        tax_percentage: 0.00,
        tax_status: null,
        transaction_type: null,
        business_tax: null
      },
      incomePayment: {
        id: null,
        year: null,
        main_quarter: null,
        partner_name: null,
        tax_description: null,
        tax_code: null,
        tax_percentage: 0.00,
        tax_status: null,
        transaction_type: null,
        business_tax: null,
        quarter: null,
        amount: 0.00,
        taxable_amount: 0.00,
        tax_withheld: 0.00,
        vat_amount: 0.00
      },
      taxCode: {
        id: null,
        code: null,
        description: null,
        percentage: 0.00,
        atc: null
      },
      tableIncomePayments: {
        perPage: 5,
        pageOptions: [5, 10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: true,
        sortDirection: 'desc',
        filter: {
          search: null,
          business_partner: null
        },
        filterOn: [],
        busy: false,
        rows: [],
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 12, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'tax_description', label: 'Tax Description' },
          { mobile: 2, key: 'tax_code', label: 'Tax Code' },
          { mobile: 3, key: 'quarter', label: 'Month of the Quarter' },
          { mobile: 4, key: 'tax_status', label: 'Tax Status' },
          { mobile: 5, key: 'business_tax', label: 'Business Tax' },
          { mobile: 6, key: 'transaction_type', label: 'Transaction Type' },
          { mobile: 7, key: 'amount', label: 'Amount', class: 'text-right', formatter: this.numberFormatter },
          { mobile: 8, key: 'tax_percentage', label: 'Tax Percentage', class: 'text-right', formatter: this.numberFormatter },
          { mobile: 9, key: 'taxable_amount', label: 'Taxable Amount', class: 'text-right', formatter: this.numberFormatter },
          { mobile: 10, key: 'amount_due', label: 'Amount Due', class: 'text-right', formatter: this.numberFormatter },
          { mobile: 11, key: 'tax_withheld', label: 'Tax Withheld', class: 'text-right', formatter: this.numberFormatter }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  watch: {
    'maskedFormManual2307.amount' (amount) {
      this.calculateVAT(amount, false)
    },

    'selected.taxCode' (taxCode) {
      this.incomePayment.tax_code = taxCode?.code || ''
      this.incomePayment.tax_description = taxCode?.description || ''
      this.incomePayment.tax_percentage = taxCode?.percentage || 0.00
    },

    'incomePayment.tax_percentage' () {
      this.calculateVAT(this.incomePayment.amount)
    },

    'incomePayment.tax_status' () {
      this.calculateVAT(this.incomePayment.amount)
    },

    'incomePayment.business_tax' () {
      this.calculateVAT(this.incomePayment.amount)
    },

    'incomePayment.transaction_type' () {
      this.calculateVAT(this.incomePayment.amount)
    }
  },

  methods: {
    rangeOfYears (start, end) {
      // Ensure the inputs are numbers
      const startYear = typeof start === 'number' ? start : new Date(start).getFullYear()
      const endYear = typeof end === 'number' ? end : new Date(end).getFullYear()

      // Create an array with the correct length and map the values
      return Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index).sort((a, b) => b - a)
    },

    calculateVAT (amount, changeAmount = true) {
      const toNumericValue = amount && amount.length && amount?.search(/[^\d.]/g) ? amount.replace(/[^\d.]/g, '') : amount
      return new Promise(resolve => {
        // this.incomePayment.is_non_recurring = Number(toNumericValue) < this.validations.amount
        const { taxAmount, taxableAmount, withHoldingTax, amountDue } = this.vatCalculator(
          toNumericValue,
          this.incomePayment.business_tax,
          this.incomePayment.tax_status,
          this.incomePayment.tax_percentage,
          this.incomePayment.transaction_type
        )

        if (changeAmount) {
          this.maskedFormManual2307.amount = toNumericValue ? parseFloat(toNumericValue || 0.00).toFixed(2) : null
        }

        this.incomePayment = Object.assign(this.incomePayment, {
          amount: toNumericValue ? parseFloat(toNumericValue || 0.00).toFixed(2) : null,
          vat_amount: taxAmount,
          taxable_amount: taxableAmount,
          tax_withheld: withHoldingTax,
          amount_due: amountDue
        })

        this.maskedFormManual2307 = Object.assign(this.maskedFormManual2307, {
          taxable_amount: taxableAmount,
          vat_amount: taxAmount,
          tax_withheld: withHoldingTax,
          amount_due: amountDue
        })

        resolve({
          amount: amount ? parseFloat(amount || 0.00).toFixed(2) : null,
          taxableAmount: taxableAmount,
          withHoldingTax: withHoldingTax,
          amountDue: amountDue
        })
      })
    },

    async getOptions () {
      this.fetching.options = true

      const filters = this.toArrayListParam([
        'business_taxes',
        'tax_codes',
        'transaction_types',
        'tax_statuses'
      ])

      return SSharedList.getCustomList(filters).then(
        ({ data }) => {
          this.options = Object.assign(this.options, {
            businessTaxes: data.business_taxes,
            taxCodes: data.tax_codes,
            transactionTypes: data.transaction_types,
            taxStatuses: data.tax_statuses
          })
          return data
        }
      ).catch(() => {
        this.options = Object.assign(this.options, {
          businessTaxes: [],
          taxCodes: [],
          transactionTypes: [],
          taxStatuses: []
        })
        return []
      }).finally(() => {
        this.fetching.options = false
      })
    },

    createManual2307 (businessPartner) {
      this.state.editing = false

      this.tableIncomePayments.rows = []

      this.maskedFormManual2307 = Object.assign(this.maskedFormManual2307, {
        amount: null,
        taxable_amount: 0.00,
        tax_withheld: 0.00,
        amount_due: 0.00
      })

      this.businessPartner = Object.assign(this.businessPartner, {
        partner_name: businessPartner.partner_name,
        tin: businessPartner.tin,
        address: businessPartner.address,
        zip_code: businessPartner?.zip_code || ''
      })

      const currentYear = new Date().getFullYear()

      this.incomePayment = Object.assign(this.incomePayment, {
        year: currentYear,
        main_quarter: '1st-Q',
        quarter: '1st-Q',
        partner_name: businessPartner.partner_name,
        tin: businessPartner.tin,
        address: businessPartner.address,
        zip_code: businessPartner?.zip_code || ''
      })

      this.options.years = this.rangeOfYears(currentYear - 3, currentYear + 1)

      this.getOptions().finally(() => {
        this.incomePayment = Object.assign(this.incomePayment, {
          tax_status: businessPartner.tax_status,
          transaction_type: businessPartner.transaction_type,
          business_tax: businessPartner.business_tax,
          tax_description: businessPartner?.tax_code?.description || '',
          tax_code: businessPartner?.tax_code?.code || '',
          tax_percentage: businessPartner?.tax_code?.percentage || 0.00
        })

        this.businessPartner = Object.assign(this.businessPartner, {
          tax_status: businessPartner.tax_status,
          transaction_type: businessPartner.transaction_type,
          business_tax: businessPartner.business_tax,
          tax_description: businessPartner?.tax_code?.description || '',
          tax_code: businessPartner?.tax_code?.code || '',
          tax_percentage: businessPartner?.tax_code?.percentage || 0.00
        })

        this.selected.taxCode = this.options.taxCodes.find(
          taxCode => taxCode.code === businessPartner.tax_code?.code
        ) || ''
      })

      this.$refs.modalManual2307.show()
    },

    validateIncomePayment () {
      this.$refs.formIncomePayments.validate().then(
        validIncomePayment => {
          const maxRowsReached = this.tableIncomePayments.rows.length >= 10
          if (!validIncomePayment || maxRowsReached) {
            if (maxRowsReached) {
              this.$refs.formIncomePayments.setErrors({
                tax: 'You have reached the maximum number of income payments allowed.'
              })
            }

            return this.swalInvalid()
          }

          if (this.state.editing) {
            const incomePayment = QUERY.find(this.tableIncomePayments.rows, {
              id: this.incomePayment.id
            })

            if (!incomePayment) {
              this.$refs.formIncomePayments.setErrors({
                tax: 'The selected income payment is invalid.'
              })

              return this.swalInvalid()
            }

            Object.assign(incomePayment, {
              partner_name: this.incomePayment.partner_name,
              tin: this.incomePayment.tin,
              address: this.incomePayment.address,
              zip_code: this.incomePayment.zip_code,
              tax_status: this.incomePayment.tax_status,
              transaction_type: this.incomePayment.transaction_type,
              business_tax: this.incomePayment.business_tax,
              tax_description: this.incomePayment.tax_description,
              tax_code: this.incomePayment.tax_code,
              tax_percentage: this.incomePayment.tax_percentage,
              quarter: this.incomePayment.quarter,
              amount: this.incomePayment.amount,
              taxable_amount: this.incomePayment.taxable_amount,
              tax_withheld: this.incomePayment.tax_withheld,
              vat_amount: this.incomePayment.vat_amount,
              amount_due: this.incomePayment.amount_due
            })

            this.state.editing = false
          } else {
            this.tableIncomePayments.rows.push({
              ...this.incomePayment,
              id: this.tableIncomePayments.rows.length + 1
            })
          }

          this.maskedFormManual2307 = Object.assign(this.maskedFormManual2307, {
            amount: null,
            taxable_amount: 0.00,
            tax_withheld: 0.00,
            amount_due: 0.00
          })

          this.$refs.formIncomePayments.reset()
        }
      )
    },

    editIncomePayment (incomePayment) {
      this.state.editing = true

      this.maskedFormManual2307 = Object.assign(this.maskedFormManual2307, {
        amount: incomePayment.amount,
        taxable_amount: incomePayment.taxable_amount,
        tax_withheld: incomePayment.tax_withheld,
        amount_due: incomePayment.amount_due
      })

      this.incomePayment = Object.assign(this.incomePayment, {
        id: incomePayment.id,
        partner_name: incomePayment.partner_name,
        tin: incomePayment.tin,
        address: incomePayment.address,
        zip_code: incomePayment?.zip_code || '',
        tax_status: incomePayment.tax_status,
        transaction_type: incomePayment.transaction_type,
        business_tax: incomePayment.business_tax,
        tax_description: incomePayment?.tax_description,
        tax_code: incomePayment?.tax_code,
        tax_percentage: incomePayment?.tax_percentage || 0.00
      })
    },

    deleteIncomePayment (incomePayment) {
      this.tableIncomePayments.rows = QUERY.filter(
        this.tableIncomePayments.rows,
        row => String(row.id) !== String(incomePayment.id)
      )
    },

    onPrint () {
      this.previewBIRForm2307({
        year: this.incomePayment.year,
        quarter: this.incomePayment.main_quarter,
        company: {
          name: process.env?.VUE_APP_BIR_FORM_COMPANY_NAME || '',
          address: process.env?.VUE_APP_BIR_FORM_COMPANY_ADDRESS || '',
          zip_code: process.env?.VUE_APP_BIR_FORM_COMPANY_ZIP_CODE || '',
          tin: process.env?.VUE_APP_BIR_FORM_COMPANY_TIN || ''
        },
        payee: {
          name: this.incomePayment.partner_name || '',
          address: this.incomePayment.address || '',
          foreign_address: '',
          zip_code: this.incomePayment.zip_code || '',
          tin: this.incomePayment.tin || ''
        },
        requester: {
          name: process.env?.VUE_APP_BIR_FORM_PAYOR_NAME || '',
          tin: process.env?.VUE_APP_BIR_FORM_PAYOR_TIN || '000-000-000-00000',
          position: process.env?.VUE_APP_BIR_FORM_PAYOR_POSITION || ''
        },
        incomePayments: this.tableIncomePayments.rows,
        moneyPayments: []
      }).then(
        onProgressBIR => {
          onProgressBIR.saveAsBase64({ dataUri: true }).then(
            pdfBIR => {
              this.pdfBIR = pdfBIR
            }
          )
        }
      ).catch(errorMessage => {
        this.swalInvalid(`<h6>${errorMessage}, please try again or contact IFAS Support Team.</h6>`)
      })

      this.$refs.modalManual2307Print.show()
    }
  }
}
</script>
